import { Progress } from "antd";
import React, { useContext } from "react";
import { ProgressContext } from "../utils/ProgressContext";
import { CloseCircleFilled } from "@ant-design/icons";

const PlaidSyncProgressLoader = ({ percent }) => {
  const { stopLoadingCross, message } = useContext(ProgressContext);
  return (
    <div
      style={{
        backdropFilter: "blur(12px)",
        position: "fixed",
        bottom: 0,
        right: "50px",
        backgroundColor: "rgba(255, 255, 255, 0.526)",
        border: "1px solid #d5d5d5",
        borderTopLeftRadius: "6px",
        borderTopRightRadius: "6px",
        padding: "1rem",
        width: "400px",
        height: "80px",
        zIndex: 99999999999999,
      }}>
      {message ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <span
            style={{ color: "green", fontWeight: "bold", fontSize: "18px" }}>
            {message}
          </span>
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              Updating Accounts: {`${percent} %`}
            </span>
            <span
              onClick={() => {
                stopLoadingCross();
              }}
              style={{ cursor: "pointer", fontWeight: "bold" }}>
              <CloseCircleFilled />
            </span>
          </div>
          <Progress
            percent={percent}
            size="small"
            strokeColor="#2a3da3"
            showInfo={false}
            strokeWidth={12}
            style={{ marginTop: "8px" }}
          />
        </>
      )}
    </div>
  );
};

export default PlaidSyncProgressLoader;
